import { render, staticRenderFns } from "./TableResponsaveisPatio.vue?vue&type=template&id=2e583a91&scoped=true&"
import script from "./TableResponsaveisPatio.vue?vue&type=script&lang=js&"
export * from "./TableResponsaveisPatio.vue?vue&type=script&lang=js&"
import style0 from "./TableResponsaveisPatio.vue?vue&type=style&index=0&id=2e583a91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e583a91",
  null
  
)

export default component.exports